module.exports = __webpack_public_path__ + "static/media/HAYThere-logo-white.4b5ce886.svg";